// Validator for phone number
export const phoneValidator = (value, callback) => {
  const phone = String(value).trim();
  if (!phone) {
    return callback('Mobile number is required');
  }

  const firstDigit = phone.charAt(0);
  if (!['6', '7', '8', '9'].includes(firstDigit)) {
    return callback('Mobile number must start with 6, 7, 8, or 9');
  }

  if (phone.length !== 10 || !/^\d+$/.test(phone)) {
    return callback('Mobile number must be exactly 10 digits long');
  }

  callback(null);
};

// International phone validator (for use with country code)
export const internationalPhoneValidator = (countryCode) => {
  return (value, callback) => {
    const phone = String(value).trim();

    if (!phone) {
      return callback('Mobile number is required');
    }

    // Check if value contains only digits
    if (!/^\d+$/.test(phone)) {
      return callback('Mobile number must contain only digits');
    }

    // Country-specific validation
    const phoneLength = phone.length;

    // India (+91) - exactly 10 digits
    if (countryCode === '+91') {
      const firstDigit = phone.charAt(0);
      if (!['6', '7', '8', '9'].includes(firstDigit)) {
        return callback('Indian mobile number must start with 6, 7, 8, or 9');
      }
      if (phoneLength !== 10) {
        return callback('Indian mobile number must be exactly 10 digits');
      }
    }
    // USA/Canada (+1) - exactly 10 digits
    else if (countryCode === '+1') {
      if (phoneLength !== 10) {
        return callback('Mobile number must be exactly 10 digits');
      }
    }
    // UK (+44) - 10 digits
    else if (countryCode === '+44') {
      if (phoneLength !== 10) {
        return callback('UK mobile number must be exactly 10 digits');
      }
    }
    // UAE (+971) - 9 digits
    else if (countryCode === '+971') {
      if (phoneLength !== 9) {
        return callback('UAE mobile number must be exactly 9 digits');
      }
    }
    // China (+86) - 11 digits
    else if (countryCode === '+86') {
      if (phoneLength !== 11) {
        return callback('Chinese mobile number must be exactly 11 digits');
      }
    }
    // Generic validation for other countries
    else {
      // Check minimum length (most countries have at least 7 digits)
      if (phoneLength < 7) {
        return callback('Mobile number must be at least 7 digits');
      }

      // Check maximum length (most countries don't exceed 15 digits)
      if (phoneLength > 15) {
        return callback('Mobile number must not exceed 15 digits');
      }
    }

    callback(null);
  };
};

// Validator for password
export const passwordValidator = (value, callback) => {
  const errorMessage =
    'Password must be at least 8 characters with at least 1 uppercase and 1 lowercase letter.';

  if (!value) {
    return callback('Password is required');
  }

  const hasUppercase = /[A-Z]/.test(value);
  const hasLowercase = /[a-z]/.test(value);
  const hasNumber = /\d/.test(value);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
  const isLongEnough = value.length >= 8;

  if (
    !hasUppercase ||
    !hasLowercase ||
    !hasNumber ||
    !hasSpecialChar ||
    !isLongEnough
  ) {
    return callback(errorMessage);
  }

  return callback(null); // Valid password
};

// Validator for confirm password
export const confirmPasswordValidator = (value, callback, password) => {
  if (!value) {
    return callback('Confirm password is required');
  } else if (password !== value) {
    return callback('Confirm password must match the password');
  }
  callback(null);
};

//newpasswordmatching
export const passwordMatchValidator = (password, value, callback) => {
  if (value === password) {
    return callback('New password cannot be the same as the current password');
  }
  callback(null);
};

// Validator for email
export const emailValidator = (message = 'Please enter a valid email') => ({
  type: 'email',
  message,
});

// Validator for gstin
export const gstinValidator = (value, callback) => {
  if (!value) {
    return callback('');
  }

  const gstinRegex = /^[A-Za-z0-9\- ]{9,15}$/;

  if (!gstinRegex.test(value)) {
    return callback('Invalid GSTIN/TAXID format');
  }

  callback(null);
};
